import React, { useState } from 'react';
import { Modal, Form, Input, Button, Tabs, Select } from 'antd';
import IntlMessages from '../../components/IntlMessage';
import { useIntl } from 'react-intl';

// import config from '../../config';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import langsApi from '../../api/langs';
import { dataSchema_type, post_params } from '../../utils/constant';
import appConfig from '../../config';
import dayjs from 'dayjs';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const { Option } = Select;

export default function LanguageForm(props) {
  const { onClose, currentData, open, code, onOpen } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingClose, setLoadingClose] = useState(false);
  const intl = useIntl();
  const [fulltext, setTFulltext] = useState(
    currentData && currentData.language && currentData.language.length > 0
      ? currentData &&
        currentData.language.find((item) => item.field.includes('fulltext'))
        ? currentData.language.find((item) => item.field.includes('fulltext'))
            .content
        : ''
      : currentData && currentData.fulltext
      ? currentData.fulltext
      : ''
  );
  const [short, setShort] = useState(
    currentData && currentData.language && currentData.language.length > 0
      ? currentData &&
        currentData.language.find((item) => item.field.includes('short'))
        ? currentData.language.find((item) => item.field.includes('short'))
            .content
        : ''
      : currentData && currentData.short
      ? currentData.short
      : ''
  );

  const handleSubmit = (close) => {
    if (close) {
      setLoadingClose(true);
    } else {
      setLoading(true);
    }

    form
      .validateFields()
      .then((values) => {
        let data = {};
        data.record_id = currentData.id;
        data.table = 'posts';
        data.code = code.code;
        data.fields = [];

        Object.entries(values).forEach(([key, value]) => {
          if (key !== 'meta_data' && key !== 'short' && key !== 'fulltext') {
            data.fields.push({ field: key, content: value.toString() });
          }
        });

        if (short) {
          data.fields.push({ field: 'short', content: short });
        }

        if (fulltext) {
          data.fields.push({ field: 'fulltext', content: fulltext });
        }

        if (Array.isArray(values.meta_data)) {
          const filteredObject = values.meta_data.reduce((acc, item) => {
            const field = Object.keys(item)[0] || '';
            const content = Object.values(item)[0] || '';
            acc[field] = content;
            return acc;
          }, {});

          data.fields.push({
            field: 'params',
            content: JSON.stringify(filteredObject),
          });
        }

        if (currentData) {
          langsApi
            .createLanguage(data)
            .then(() => {
              setLoading(false);
              setLoadingClose(false);
              if (close) {
                handleCancel();
              } else {
                onOpen(currentData, code);
              }
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
              setLoadingClose(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const handleCancel = () => {
    onClose();
  };
  // console.log('c', currentData);
  let initialValue = {
    ...currentData,
    ...(currentData && currentData.language && currentData.language.length > 0
      ? {
          title:
            currentData &&
            currentData.language.find((item) => item.field.includes('title'))
              ? currentData.language.find((item) =>
                  item.field.includes('title')
                ).content
              : '',
          description:
            currentData &&
            currentData.language.find((item) =>
              item.field.includes('description')
            )
              ? currentData.language.find((item) =>
                  item.field.includes('description')
                ).content
              : '',
          short:
            currentData &&
            currentData.language.find((item) => item.field.includes('short'))
              ? currentData.language.find((item) =>
                  item.field.includes('short')
                ).content
              : '',
          fulltext:
            currentData &&
            currentData.language.find((item) => item.field.includes('fulltext'))
              ? currentData.language.find((item) =>
                  item.field.includes('fulltext')
                ).content
              : '',
          image_alt:
            currentData &&
            currentData.language.find((item) =>
              item.field.includes('image_alt')
            )
              ? currentData.language.find((item) =>
                  item.field.includes('image_alt')
                ).content
              : '',
          meta_data:
            currentData && currentData.language
              ? post_params &&
                post_params.map((key) => ({
                  [key]: currentData.language.find((item) =>
                    item.field.includes('params')
                  )
                    ? JSON.parse(
                        currentData.language.find((item) =>
                          item.field.includes('params')
                        ).content
                      )[key] || ''
                    : '',
                }))
              : post_params &&
                post_params.map((key) => ({
                  [key]: '',
                })),
        }
      : {
          meta_data:
            currentData && currentData.params
              ? post_params.map((key) => ({
                  [key]:
                    currentData && currentData.params
                      ? JSON.parse(currentData.params)[key] || ''
                      : '',
                }))
              : post_params.map((key) => ({
                  [key]: '',
                })),
        }),
  };

  const tabItems = [
    {
      key: '1',
      label: <IntlMessages id="global.posts" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessages id="global.title" />}
            name="title"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={<IntlMessages id="global.image_alt" />}
            name="image_alt"
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item>
        </>
      ),
    },
    {
      key: '2',
      label: <IntlMessages id="post.short" />,
      className: 'contact_info',
      children: (
        <>
          <Form.Item name="short">
            <CKEditor
              editor={ClassicEditor}
              // config={{
              //   ckfinder: {
              //     uploadUrl: `${appConfig.API_URL}/images/upload`,
              //     withCredentials: true,
              //   },
              // }}
              onChange={(event, editor) => {
                setShort(editor.getData());
              }}
              data={short}
              // onChange={handleEditorChange}
            />
          </Form.Item>
        </>
      ),
    },
    {
      key: '3',
      label: <IntlMessages id="post.fulltext" />,
      className: 'contact_info',
      children: (
        <>
          <Form.Item
            name="fulltext"
            rules={[
              {
                required: false,
              },
            ]}
            // valuePropName="data"
            // getValueFromEvent={(event, editor) => {
            //   const data = editor.getData();
            //   // console.log({ event, editor, data });
            //   return data;
            // }}
          >
            <CKEditor
              editor={ClassicEditor}
              config={{
                ckfinder: {
                  uploadUrl: `${appConfig.API_URL}/images/upload`,
                  withCredentials: true,
                },
              }}
              onChange={(event, editor) => {
                setTFulltext(editor.getData());
              }}
              data={fulltext}
              // onChange={handleEditorChange}
            />
          </Form.Item>
        </>
      ),
    },
    {
      key: '4',
      label: <IntlMessages id="global.meta_data" />,
      forceRender: true,
      children: (
        <>
          <Form.List name="meta_data">
            {(fields, { add }) => (
              <>
                {fields.map((field, index) => {
                  const param = post_params[index];

                  if (param === 'schema_type') {
                    return (
                      <Form.Item
                        key={field.key}
                        label={<IntlMessages id={`global.${param}`} />}
                        name={[index, param]}
                      >
                        <Select
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {dataSchema_type?.map((schema_type, index) => (
                            <Option key={schema_type} value={schema_type}>
                              {schema_type}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    );
                  } else
                    return (
                      <Form.Item
                        key={field.key}
                        label={<IntlMessages id={`global.${param}`} />}
                        name={[index, param]}
                      >
                        <Input />
                      </Form.Item>
                    );
                })}
              </>
            )}
          </Form.List>
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        currentData ? (
          <>
            <IntlMessages id="global.edit" /> - {code.image_name}
          </>
        ) : (
          <IntlMessages id="global.add" />
        )
      }
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="60%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessages id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={() => handleSubmit(false)}
        >
          {<IntlMessages id="global.save" />}
        </Button>,
        <Button
          key="submit&close"
          type="primary"
          htmlType="submit"
          loading={loadingClose}
          onClick={() => handleSubmit(true)}
        >
          {<IntlMessages id="global.save_and_close" />}
        </Button>,
      ]}
    >
      <Form
        {...layout}
        form={form}
        initialValues={initialValue}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
      </Form>
    </Modal>
  );
}
